
import React, {useEffect, useState} from 'react'
import { Link, useHistory, useLocation } from "react-router-dom";
import { Accordion, Card } from "react-bootstrap";
import styled from 'styled-components';
import {ArrowDropDown} from "../../../../../components/AllSvgIcon"
import { set } from 'lodash';
import { AirplanemodeActiveRounded } from '@material-ui/icons';

const SubNavMenu = (props) => {
    const { pathname, search } = useLocation();
    const [activeCategory, setActiveCategory] = useState("")
    let history = useHistory();

    let string = pathname.split("/");
    let mql = window.matchMedia("all and (min-width: 769px)");
    let mqs = window.matchMedia("all and (max-width: 768px)");
    const lang = localStorage.getItem('lang') || 'en';

    const handleCategorySelection = async (e, cat_name, cat_ref_id, cat_id) => {
        e.preventDefault();
        
        if(props.props.cartType && props.props.cartType === 'express') {
            return
        }
        else {
          window.scrollTo(0,0);
          localStorage.setItem("cat_id",cat_id);
          localStorage.setItem("subcatname","");
          localStorage.setItem("sub_cat_id",-1);
          if(props.oos === true){
            localStorage.setItem("mode","catoos");
            // props.props.resetPage();
            if(mqs.matches){
              props.props.getProductOutOfStockCat({ cat_id: cat_id, store_id: 1, page: 1, lang });
            }
          }
          else{
            localStorage.setItem("mode","cat");
            // props.props.resetPage();
            if(mqs.matches){
              props.props.getProductsMappedwithCat({ cat_id: cat_id, store_id: 1, page: 1 });
            }
          }
    
          history.push({pathname: `/category/${cat_ref_id}`, state: { cat_name: cat_name },});
        //   sethoveredCat(cat_ref_id);
          window.location.href = `/category/${cat_ref_id}`;
        }
      };
    const handleSubCategoryClick = async (parent, child) => {
          window.scrollTo(0,0);
          if (child.sub_cat_id === localStorage.getItem("sub_cat_id")) {
            // setSubActive(child.sub_cat_id);
          }
          if(props.oos === 1){
            localStorage.setItem("mode","subcatoos");
            // props.props.resetPage();
            if(mqs.matches){
              props.props.getProductOutOfStock({
                sub_cat_id: child.sub_cat_id,
                store_id: 1,
                page: 1,
                lang
              })
            }
          }
          else{
            localStorage.setItem("mode","subcat");
            // props.props.resetPage();
            if (mqs.matches){
              props.props.getProductsMappedwithSubCat({
                sub_cat_id: child.sub_cat_id,
                store_id: 1,
                page: 1,
                oos: 0,
                lang
              });
            }
          }
          localStorage.setItem("subcatname", child.name);
          localStorage.setItem("sub_cat_id",child.sub_cat_id);
          // if(child.sub_cat_id !== 187 && window.location.pathname === "/"){
          history.push({
            pathname: `/category/${parent.cat_ref_id}/${child.sub_cat_ref_id}`,
            state: { cat_name: parent.cat_name, sub_cat_name: child.name },
          });
          // }
          if (mqs.matches){
            if(document.getElementsByClassName("drawer__close")){
              document.getElementsByClassName("drawer__close")[0].click();
            }
          }
          window.location.href = `/category/${parent.cat_ref_id}/${child.sub_cat_ref_id}`;
    }
 
    return(
        <>
        {typeof props.categories !== 'undefined' && props.categories === "new" ?
          <CategoriesContainer>
            <CategoryContainer>
              <SubCategory onClick={(e) => {
                e.preventDefault()
                window.location.href = "/best-deals/new-arrivals"
              }}>
                <div className='new_sub'>
                  <span>New Arrivals</span>
                </div>
              </SubCategory>
              <SubCategory onClick={(e) => {
                e.preventDefault()
                window.location.href = "/best-deals/promotions"
              }}>
                <div className='new_sub'>
                  <span>Promotions</span>
                </div>
              </SubCategory>
              <SubCategory onClick={(e) => {
                e.preventDefault()
                window.location.href = "/best-deals/best-seller"
              }}>
                <div className='new_sub'>
                  <span>Best Sellers</span>
                </div>
              </SubCategory>
            </CategoryContainer>
          </CategoriesContainer>
          : typeof props.categories !== 'undefined' && props.categories !== null ? (
            <CategoriesContainer>
                {props.categories.map((category, key) => {
                    return(
                        <CategoryContainer key={key}>
                            <CategoryHeader>
                                {/* <div onClick={(e)=>{handleCategorySelection(e, category.name, category.cat_ref_id, category.cat_id)}}>
                                    <img src={category.image} width="30" alt={"caticon"} />
                                    <span style={{ paddingLeft: "5px" }}>{category.name}</span>
                                </div> */}
                                <div onClick={(e)=>{handleCategorySelection(e, category.list_categories[0].name, category.list_categories[0].cat_ref_id, category.list_categories[0].cat_id)}}>
                                    {/* <img src={category.list_categories[0].image} width="20" alt={"caticon"} /> */}
                                    <span>{category.list_categories[0].name}</span>
                                </div>
                            </CategoryHeader>
                                    {
                                        category.list_categories[0].map_categories_sub_cats.map((subCategory) => {
                                            return(
                                                <SubCategory key={subCategory.list_sub_categories[0].sub_cat_id} onClick={(e)=>{handleSubCategoryClick(category.list_categories[0], subCategory.list_sub_categories[0])}}>
                                                    <span>{subCategory.list_sub_categories[0].name}</span>
                                                </SubCategory>
                                            )
                                        })
                                    }
                        </CategoryContainer>
                    )
                })}
            </CategoriesContainer>
        ):(
            <div>NO catagory</div>
        )}
        </>
    )
}

export default SubNavMenu;

const CategoriesContainer = styled.div`
    // display: flex;
    // flex-wrap: wrap;
    // align-items: flex-start
    columns: 3 auto;
`;
const CategoryContainer = styled.ul`
    padding-bottom: 15px;
    margin: 0 0 1rem;

    break-inside: avoid;
`;
const CategoryHeader =styled.li`
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    font-weight: 600;
    text-transform: uppercase;
    text-decoration: underline;
    text-underline-offset: 5px;
    margin-bottom: 20px;

    &>div{
      cursor: pointer;
    }
    &>div:hover span{
      font-weight: 900;
    }
`;
const SubCategoryContainer = styled.div`
    border-top: 1px solid #f1f1f1;
    max-height: 400px;
    overflow-y: auto;
`
const SubCategory = styled.li`
    font-size: 13px;
    text-transform: uppercase;
    .new_sub{
      span{
        font-size: 15px;
        font-weight: 600;
        &:hover {
          font-weight: 800;
        }
      }
    }
    span {
      cursor: pointer;
    }
    &:hover span {
      font-weight: 600;
    }
`